module.exports = __webpack_public_path__ + "src/assets/login_rt_bg.png";